module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRx-Program-Video.3606ac2d.jpg";